import {
  primaryColor,
  primaryBoxShadow,
  successColor,
  dangerColor,
  blackColor,
  lightGrayColor,
  whiteColor,
} from '../../../assets/styles/jss/main';

export default {
  selectFormControl: {
    margin: '7px 1px 10px 0px !important',
    '& > div': {
      '&:before': {
        borderColor: '#D2D2D2 !important',
        borderWidth: '1px !important',
      },
      '&:after': {
        borderColor: primaryColor,
      },
    },
  },
  selectMenu: {
    '& > div': {
      boxSizing: 'borderBox',
      borderRadius: '0 !important',
      padding: '0',
      minWidth: '100%',
      display: 'block',
      border: '0',
      boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.26)',
      backgroundClip: 'padding-box',
      margin: '1px 0 0',
      fontSize: '16px',
      textAlign: 'left',
      listStyle: 'none',
      backgroundColor: 'transparent',
    },
    '& > div > ul': {
      border: 0,
      borderRadius: '0 !important',
      padding: '5px 0',
      margin: '0',
      boxShadow: 'none',
      minWidth: '100%',
      boxSizing: 'border-box',
      display: 'block',
      fontSize: '16px',
      textAlign: 'left',
      listStyle: 'none',
      backgroundColor: '#fff',
      backgroundClip: 'padding-box',
    },
  },
  selectMenuItem: {
    fontSize: '13px',
    padding: '10px 20px',
    margin: '0 5px',
    borderRadius: '2px',
    transition: 'all 150ms linear',
    display: 'block',
    clear: 'both',
    fontWeight: '400',
    lineHeight: '2',
    whiteSpace: 'nowrap',
    color: '#333',
    '&:hover': {
      backgroundColor: primaryColor,
      color: '#FFFFFF',
      ...primaryBoxShadow,
    },
  },
  selectMenuItemSelected: {
    backgroundColor: `${primaryColor}!important`,
    color: '#FFFFFF',
  },
  select: {
    textAlign: 'left',
    color: blackColor,
    fontSize: '16px',
    padding: '12px 7px',
    border: '2px solid #ececee',
    background: lightGrayColor,
    borderRadius: '5px',
    '&[aria-owns] + input + svg': {
      transform: 'rotate(180deg)',
    },
    '& + input + svg': {
      transition: 'all 300ms linear',
    },
    '&:focus': {
      borderRadius: '5px',
    },
  },
  selectSuccess: {
    borderColor: successColor,
  },
  selectError: {
    borderColor: dangerColor,
  },
  // successClass (for icon Check)
  labelRootSuccess: {
    color: successColor,
  },
  feedback: {
    position: 'absolute',
    bottom: 23,
    right: 23,
    zIndex: 2,
    display: 'block',
    width: 24,
    height: 24,
    textAlign: 'center',
    pointerEvents: 'none',
  },
  feedbackWithHelp: {
    bottom: 0,
    top: 15,
  },
  selectLabelSuccess: {
    color: `${successColor} !important`,
  },
  selectLabelError: {
    color: `${dangerColor} !important`,
  },
  white: {
    background: whiteColor,
    border: 'none',
  },
};
